"use strict";
function calculateSavingsPercentage(price, comparePrice) {
    if (!price || !comparePrice) {
        return 0;
    }
    var priceNumber = Number(price.replace(/[^0-9.-]+/g, ""));
    var comparePriceNumber = Number(comparePrice.replace(/[^0-9.-]+/g, ""));
    if (priceNumber === 0 || comparePriceNumber === 0) {
        return 0;
    }
    var savingsPercentage = ((comparePriceNumber - priceNumber) / comparePriceNumber) * 100;
    if (savingsPercentage < 1) {
        return 0;
    }
    return parseInt((savingsPercentage + 0.5).toString());
}
function setSavingsBadge(savingsBadgeSpan, price, comparePrice) {
    var _a, _b;
    var savingsPercentage = calculateSavingsPercentage(price, comparePrice);
    if (savingsPercentage < 1) {
        (_a = savingsBadgeSpan === null || savingsBadgeSpan === void 0 ? void 0 : savingsBadgeSpan.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
        return;
    }
    (_b = savingsBadgeSpan === null || savingsBadgeSpan === void 0 ? void 0 : savingsBadgeSpan.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    savingsBadgeSpan.innerHTML = "".concat(savingsPercentage, "%");
}
function calculateSavingsAmount(price, comparePrice) {
    if (!price || !comparePrice) {
        return "0.00";
    }
    var priceNumber = Number(price.replace(/[^0-9.-]+/g, ""));
    var comparePriceNumber = Number(comparePrice.replace(/[^0-9.-]+/g, ""));
    if (priceNumber === 0 || comparePriceNumber === 0) {
        return "0.00";
    }
    var savingsAmount = comparePriceNumber - priceNumber;
    // if (savingsAmount < 1) {
    //   return "0.00";
    // }
    return savingsAmount.toFixed(2);
}
function setComparePriceSavingsAmount(savingsAmountSpan, price, comparePrice) {
    var _a, _b;
    var savingsAmount = calculateSavingsAmount(price, comparePrice);
    if (savingsAmount === "0.00") {
        (_a = savingsAmountSpan === null || savingsAmountSpan === void 0 ? void 0 : savingsAmountSpan.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
        return;
    }
    (_b = savingsAmountSpan === null || savingsAmountSpan === void 0 ? void 0 : savingsAmountSpan.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    savingsAmountSpan.innerHTML = "R" + savingsAmount;
}
function parseRandToCents(input) {
    var cleaned = input.replace(/[^0-9.]/g, "");
    var amount = parseFloat(cleaned);
    if (isNaN(amount)) {
        throw new Error("Invalid currency format: ".concat(input));
    }
    return Math.round(amount * 100);
}
